import { render, staticRenderFns } from "./PomPayTransaction.vue?vue&type=template&id=653fdb44"
import script from "./PomPayTransaction.vue?vue&type=script&lang=js"
export * from "./PomPayTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports